// src/pages/AuditLogsPage.jsx
// Standalone HIPAA Audit Logs page for admin users

import React from "react";
import AuditLogs from "../components/AuditLogs";

const AuditLogsPage = () => {
  return (
    <div className="p-6 md:p-8 max-w-7xl mx-auto">
      <AuditLogs />
    </div>
  );
};

export default AuditLogsPage;
